import React, {useEffect, useState} from 'react'
import { useModal, useNFTContext } from "../../../utils/ModalContext";
import Button from "../../button";
import MintModalStyleWrapper from "./MintNow.style";
import mintImg from "../../../assets/images/unrevealed-alpha.gif";
import hoverShape from "../../../assets/images/icon/hov_shape_L.svg";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FaMinus } from "react-icons/fa";
import { BsConeStriped, BsPlusLg } from "react-icons/bs";
import { FiX } from "react-icons/fi";
import { ImSpinner } from "react-icons/im";
import Web3 from 'web3';
import { useApiContract, useMoralis, useNativeBalance, useNFTTransfers, useWeb3Contract } from 'react-moralis';
import { mint, presaleMint } from '../../../controllers/nft';
import abi from "../../../controllers/abi.json";
import testAbi from "../../../controllers/ropsten-abit.json";

const options = {
  address:process.env.REACT_APP_CONTRACT_ADDRESS,
  abi:abi,
  chain: process.env.REACT_APP_CHAIN_ID
}
const MintNowModal = () => {

  
  
  const {saleStart, isPresaleOpen, salePrice, count, countHandle, userBalance, presalePrice, salePriceETH, presalePriceETH, maxReserved, maxPublic, maxPrivate, maxElements, totalMint} = useNFTContext();
  const {user, isAuthenticated, Moralis} = useMoralis();
  const { mintModalHandle, messageHandle ,oopsModalHandle, successModalHandle, hashHandle,walletMoadalHandle} = useModal();
  const [txHash, setHash] = useState('');
  const {data:isWhitelisted, runContractFunction:getWhitelist, isLoading:whitelistLoading} = useApiContract({...options, functionName: 'addressInWhitelist', params:{addr: user?.get('ethAddress')}});
  const [mintLoading, setLoading] = useState(false);
  const [quota, setQuota] = useState('');

  const {data:saleCP, runContractFunction:getSalePriceByCount, isFetching:saleCPLoading} = useApiContract({...options, functionName: 'salePrice', params:{_count: count || 1}});
  const {data:presaleCP, runContractFunction:getPresalePriceByCount, isFetching:presaleCPLoading} = useApiContract({...options, functionName: 'presalePrice', params:{_count: count || 1}});
  const { fetch, data:transfers, error, isLoading, isFetching } = useNFTTransfers();
  useEffect(() => {
    // if(count > maxPrivate) {
    //   // mintModalHandle()
    //   messageHandle(`Only ${maxPrivate} alpha octopus can be minted per each Wallet Address.`)
    //   oopsModalHandle();}
    // else if(price != count*salePrice) {
    //   messageHandle("Please select the correct count.");
    //   oopsModalHandle();
    async function fetchData() {
      
      await getWhitelist();
      await getSalePriceByCount();
      await getPresalePriceByCount();
      // fetch({params: {direction: 'to'}});
      const res = transfers?.result?.filter((item) => item.token_address === "0x42726006076b592e9ab4d773237470e4179f2bd5");
      setQuota(res?.length);
      console.log('res transfer', res);

    }
    // }
    fetchData();
  }, [count, isWhitelisted, transfers])

  const max = isPresaleOpen ? maxPrivate : maxPublic;
  const price = isPresaleOpen ? presalePrice : salePrice;
  const priceByCount = isPresaleOpen ? Number(Moralis.Units.FromWei(presaleCP || 0, 'ether')) : Number(Moralis.Units.FromWei(saleCP || 0, 'ether'));
  const priceInETH = isPresaleOpen ? presalePriceETH : salePriceETH;
  console.log("modal",quota, (max-quota))

  const mintAlphaOctopus = async() => {
    setLoading(true);
    if(isAuthenticated){
      console.log("running");
      if(count > max) {
        mintModalHandle();
        messageHandle(`Only ${maxPrivate} alpha octopus can be minted per each Wallet Address.`)
        oopsModalHandle();
        console.log("count");
      }
      else if(priceByCount != count*priceInETH) {
        mintModalHandle();
        messageHandle("Please select the correct count.");
        oopsModalHandle();
        console.log("price", priceByCount, count*priceInETH);
      }else{
        if(isPresaleOpen){
          console.log("running");
          const tx = await presaleMint(count, priceByCount);
          console.log("tx",tx)
          if(tx){
            setHash(tx.transactionHash || tx.hash);
            setLoading(false);
            hashHandle(tx.transactionHash || tx.hash);
            mintModalHandle();
            successModalHandle();
          }
          else{

            setLoading(false);
            messageHandle("Something went wrong. Please try again.");
            
            oopsModalHandle();
          }
        }
        else{
          console.log('running');
          const tx = await mint(count, priceByCount);
          if(tx){
            setHash(tx.transactionHash || tx.hash);
            setLoading(false);
            hashHandle(tx.transactionHash || tx.hash);
            successModalHandle();
            mintModalHandle();
          }
          else{
            setLoading(false);
            messageHandle("Something went wrong. Please try again.");
            oopsModalHandle();
          }
        }
      }

    }
    else{
      walletMoadalHandle();
      mintModalHandle();
    }
    
  }
// console.log('whitelist', isWhitelisted);
  return (
    <>
    <MintModalStyleWrapper className="modal_overlay">
      <div className="mint_modal_box">
      {/* {
        mintLoading && 
          <div className="modal-loading">
            <div className="loading_icon">
              <ImSpinner size={40} color="white" />
              </div>
          </div>
          } */}
        <div className="mint_modal_content" 
          // style={{opacity:mintLoading ? 0.4 : 1}}
        >
          <div className="modal_header">
            {/* <h2>{isOpen? `Collect YOUR ALPHA OCTOPUS at 15% discount` : `Collect your ALPHA OCTOPUS`}</h2> */}
            <button style={{cursor:"pointer"}} onClick={() => mintModalHandle()}>
              <FiX />
            </button>
            {quota >0 && <span>{`Hurrah! 🎉 You already have ${quota} ALPHA OCTOPUS In Your Wallet, Let's Mint More `}</span>}

          </div>
          {!mintLoading ? 
          <div className="modal_body text-center">
            <div className="mint_img">
              <img src={mintImg} alt="ALPHA OCTOPUS nft mint" style={{height:250, width:250}} />
            </div>
            <div className="mint_count_list">
              <ul>
                <li>
                  <h5>Remaining</h5>
                  <h5>
                    {(maxElements - (totalMint + maxReserved + count))}/                  
                    <span>{maxElements}</span>
                  </h5>
                </li>
                <li>
                  <h5>Price</h5>
                  <h5>{priceInETH} ETH</h5>
                </li>
                <li>
                  <h5>Quantity</h5>
                  <div className="mint_quantity_sect">
                    <button
                      onClick={
                        () => {count > 1  ?  countHandle( count - 1) : countHandle(1)}
                      }
                    >
                      <FaMinus />
                    </button>
                    <input
                      type="text"
                      id="quantity"
                      value={count}
                      onChange={(e) => {countHandle(e.target.value)}}
                      max={max-quota}
                      min={1}
                    />
                    <button onClick={() => count<(max) ? countHandle( count + 1) : alert(`you can't mint more than ${max} in ${isPresaleOpen? 'Private ': 'Public'} Mint`)} > <BsPlusLg /></button>
                  </div>
                  <h5>
                    <span>{ (saleCPLoading || presaleCPLoading) ? <ImSpinner /> : priceByCount}</span> ETH
                  </h5>
                </li>
              </ul>
            </div>
            <div className="modal_mint_btn">
              {!isWhitelisted && <span className="text-warning bg-danger shadow-large p-2 rounded fw-bold" >{'Not whitelisted to mint ALPHA OCTOPUS'}</span>}
              {count > (max-quota) && <span className="text-dark bg-danger shadow-large p-2 rounded fw-bold" >{`Max(${max}) limit Reached for this address`}</span>}
              <span style={{color:'red', backgroundColor:'yellow'}}>{(userBalance == 0) || (userBalance < (priceByCount)) && 'You dont have enough balance to Proceed further'}</span>
              <Button lg 
                variant="mint" 
                className="mt-3"
                disabled={count > (max-quota) || !isWhitelisted || (userBalance == 0) || (userBalance < (priceByCount))}
                onClick={() => mintAlphaOctopus()}  // disabled={!isWhitelisted}
              >
                Mint Now
              </Button>
            </div>
          </div>
         :
          <div className="modal-body text-center">
            <ImSpinner size={40} color="white" />
            <h5>Confirm a transaction in your wallet</h5>
            <h5>Please wait...</h5>
            {txHash && <p onClick={() => window.open(`https://ropsten.etherscan.io/tx/${txHash}`, "_blank")}>See transaction in Etherscan</p>}
          </div>
          }

          <div className="modal_bottom_shape_wrap">
            <span className="modal_bottom_shape shape_left">
              <img src={hoverShape} alt="bithu nft hover shape" />
            </span>
            <span className="modal_bottom_shape shape_right">
              <img src={hoverShape} alt="bithu nft hover shape" />
            </span>
          </div>
        </div>
      </div>
    </MintModalStyleWrapper>
  </>
  )
}

export default MintNowModal